import styled from "styled-components/macro"
import theme from "theme"

export const ValueWrap = styled.div`
  border-top: 1px solid ${theme.color.border};
  padding: 10px;
`
